function clientConfig() {
  const isItNew2 = process.env.NEW2 === 'true';
  const isLocal = process.env.LOCAL === 'true';
  const isMirror = process.env.IS_MIRROR === 'true';
  const backendApi = process.env.BACKEND_API || 'backend-nginx';
  if (process.env.NEW2 === 'true') {
    console.warn('NEW2:', true);
  }

  if (process.env.COUNTRY) {
    console.log(`It is ${process.env.COUNTRY} config...`);
    const getConfig = require(`./config.${process.env.COUNTRY}`);
    console.log('isMirror', isMirror);
    console.log('backendApi', backendApi);
    return getConfig(isItNew2, isLocal, isMirror, backendApi);
  }
  console.log('^_^ where is your country config?');
  return null;
}

module.exports = clientConfig();
